// This module depends on ALL adapters, which exacerbates module initialization time circular import issues.
// To avoid this, we inline all imports in `getTypedStudyAdapters`.
import {assert} from 'Asserts';
import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import lazyInit from 'util/lazyInit';

import type {AssayDevelopmentStudyAdapter} from './assay-development/AssayDevelopmentStudyAdapter';
import type {ClinicalStudyAdapter} from './clinical/ClinicalStudyAdapter';
import type {CustomStudyAdapter} from './custom/CustomStudyAdapter';
import type {PreclinicalStudyAdapter} from './preclinical/PreclinicalStudyAdapter';
import type {ProcessDevelopmentStudyAdapter} from './process-development/ProcessDevelopmentStudyAdapter';
import {TypedStudyAdapter} from './utils/TypedStudyTypes';

/**
 * @package exported for testing
 */
export const getTypedStudyAdapters = lazyInit<Record<StudyType, TypedStudyAdapter | undefined>>(() => ({
  [StudyType.CUSTOM]: require('./custom/CustomStudyAdapter').CustomStudyAdapter as typeof CustomStudyAdapter,
  [StudyType.PROCESS_DEVELOPMENT]: require('./process-development/ProcessDevelopmentStudyAdapter')
    .ProcessDevelopmentStudyAdapter as typeof ProcessDevelopmentStudyAdapter,
  [StudyType.ASSAY_DEVELOPMENT]: require('./assay-development/AssayDevelopmentStudyAdapter')
    .AssayDevelopmentStudyAdapter as typeof AssayDevelopmentStudyAdapter,
  [StudyType.CLINICAL]: require('./clinical/ClinicalStudyAdapter')
    .ClinicalStudyAdapter as typeof ClinicalStudyAdapter,
  [StudyType.PRECLINICAL]: require('./preclinical/PreclinicalStudyAdapter')
    .PreclinicalStudyAdapter as typeof PreclinicalStudyAdapter,
}));

export function getTypedStudyAdapter(type: StudyType): TypedStudyAdapter {
  const adapter = getTypedStudyAdapters()[type];
  assert(adapter != null, `No adapter found for study type ${type}`);
  return adapter;
}
